export default __webpack_public_path__ + "static/debt-7481a821c15329f6a822a544a81692fe.webp";